import React, { useState } from "react";

const CustomerStatusTable = (props) => {
    const { customers = [], activeStores = [] } = props
    const [searchTerm, setSearchTerm] = useState("");


    const filteredStores = customers.filter((customer) =>
        customer.toLowerCase().startsWith(searchTerm.toLowerCase())
    );


    const handleRowClick = (store) => {
        alert(`You clicked on store: ${store}`);
    };

    return (
        <div>

            <input
                type="text"
                placeholder="Search by customer name..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
                style={{
                    marginBottom: "10px",
                    padding: "5px 10px",
                    width: "50%",
                    fontSize: "16px",
                }}
            />
            <table border="1" cellPadding="10" style={{ borderCollapse: "collapse", width: "600px" }}>
                <thead>
                    <tr>
                        <th>Customer </th>
                        <th>Status</th>
                    </tr>
                </thead>
                <tbody>
                    {filteredStores?.map((store) => {
                        const isActive = true // we have to replace with order ,get orders from DB and see is that customer Active or not
                        return (
                            <tr
                                key={store}
                                onClick={() => handleRowClick(store)}
                                style={{ cursor: "pointer" }}
                            >
                                <td>{store}</td>
                                <td style={{ color: isActive ? "green" : "red" }}>
                                    {isActive ? "🟢 Active" : "🔴 Inactive"}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

export default CustomerStatusTable;